import { Component } from '@angular/core';
import { DealerPortalService } from 'src/app/services/dealerPortal.service';
import { Subscription } from 'rxjs';
import { CustomerService } from 'src/app/services/customer.service';
import { Router } from '@angular/router';
import { NzTableQueryParams } from 'ng-zorro-antd/table';

interface AnnualOverview {
    currentTargetAchievement: number;
    annualPurchaseTarget: string;
    actualPurchaseAmount: string; // 可选属性
    quarterlyTarget: string; // 只读属性
    pendingPurchaseAmountYTM: string;
    quarterlyPendingPurchaseAmount: string
};
@Component({
    selector: 'app-target-achievement',
    templateUrl: './target-achievement.component.html',
    styleUrls: ['./target-achievement.component.less']
})
export class TargetAchievementComponent {
    selectedYear = localStorage.getItem("selectedYear") ? localStorage.getItem("selectedYear") : '';
    Math = Math;
    private customerSubscription: Subscription | undefined;
    selectedYearForInit = '';
    yearList = [];
    latestUpdateTime = '';
    annualOverviews = [];
    annualResult:any;
    indicatorList = [
        {
            label:"目标返利金额",
            value:0,
            color:"#9E2896",
            key:"TargetRebateAmount",
            tab:"target",
            tips:"目标返利金额（含税）：按照合同约定完成目标后可得含税返利金额"
        },
        // {
        //     label:"预计返利金额",
        //     value:0,
        //     color:"#F19F23",
        //     key:"EstimatedRebateAmount",
        //     tab:"estimated",
        //     tips:"预计返利金额（含税），仅供参考，以最终结算结果为准"
        // },
        {
            label:"已发放返利金额",
            value:0,
            color:"#18817D",
            key:"IssuedRebateAmount",
            tab:"released",
            tips:"已发放返利金额：客户已确认发放的返利金额（本年度所有合同相关）"
        },
        {
            label:"已使用返利金额",
            value:0,
            color:"#007AC0",
            key:"UsedRebateAmount",
            tab:"used",
            tips:"已使用返利金额（含税）：客户已使用的返利金额"
        }
    ];
    annualOverview: AnnualOverview = {
        currentTargetAchievement: 0,
        annualPurchaseTarget: '0',
        actualPurchaseAmount: '0',
        quarterlyTarget: '0',
        pendingPurchaseAmountYTM: '0',
        quarterlyPendingPurchaseAmount: '0'
    };
    cbfTarget: any[] = [];
    blockData: any[] = [];
    pageHeaderTitle = '';
    firstLoading: boolean = true;
    percentFormat = (percent: number): string => `${percent}%`;
    rows: any[][] = [];
    cardWidth = 0;

    iconMap: any = {
        '柴油系统': 'assets/target/sensor-diesel-rpm.png',
        '滤清器': 'assets/target/oil-filter-change.png',
        '电喷系统': 'assets/target/EDC-inline-injection-pump-PES6P.png',
        '转向系统': 'assets/target/steering-system-steer-by-wire.png',
        '电瓶': 'assets/target/battery-car-flash.png',
        '汽车电子': 'assets/target/control-unit-ecu.png',
        '火花塞': 'assets/target/spark-plug.png',
        '起发电机': 'assets/target/generator.png',
        '维修店': 'assets/target/store.png',
        '舒适电子': 'assets/target/chip.png',
        '润滑油': 'assets/target/oil-barrel.png',
        '刹车片': 'assets/target/brake-system-ESP.png',
        '雨刮片': 'assets/target/wiper-blade.png',
    };

    constructor(
        private dealerPortalService: DealerPortalService,
        private router: Router,
        private customerService: CustomerService,
    ) { }

    ngOnInit(): void {
        this.initData().then(() => {
            this.firstLoading = false;
        })
        this.customerSubscription = this.customerService.selectedCustomer$.subscribe(() => {
            if (!this.firstLoading && this.router.url.includes('/target-achievement')) {
                this.initData();
            }
        });
    }

    checkChildNodes(childNodes: any[], title: string): boolean {
        return childNodes.some((child: any) =>
          child.url === title || (child.childNode && this.checkChildNodes(child.childNode, title))
        );
      }

    hasPermission(title: string): boolean {
        const menuData = JSON.parse(localStorage.getItem('menu') || '[]');
        // only check childNote
        return menuData.some((menu: any) =>
          menu.childNode && this.checkChildNodes(menu.childNode, title)
        );
      }

      goPage(url: string, data: any): void {
        const country = localStorage.getItem("country");
        this.router.navigate([`${country}/${url}`], { queryParams: { tabSelectNumber:1,type: data } });
      }

    onYearChange(year: string) {
        localStorage.setItem("selectedYear", year);
        this.getAnnualCbfTargetAndPurchase(year)
        this.getMainContractAnnualTargetAchieve(year)
    }

    initData(): Promise<void> {
        return new Promise((resolve) => {
            if (this.selectedYear) {
                this.getAnnualCbfTargetAndPurchase(this.selectedYear)
                this.getMainContractAnnualTargetAchieve(this.selectedYear)
            } else {
                this.getAnnualCbfTargetAndPurchase('')
                this.getMainContractAnnualTargetAchieve('')
            }
            resolve();
        })
    }

    ngOnDestroy(): void {
        if (this.customerSubscription) {
            this.customerSubscription.unsubscribe();
        }
    }

    onCardClick(value: any, tab: any) {
        if (value !== 0 && value != null) {
            if (tab === 'used') {
                this.goPage('/contracts_rebates', tab)
            }
            if (tab === 'released') {
                const country = localStorage.getItem("country");
                this.router.navigate([`${country}/contracts_rebates`]);
            }
        }
    }

    splitIntoRows(items: any[]): any[][] {
        const maxItemsBeforeSplit = 4;
        const result = [];
        const lineCount = this.Math.ceil(items.length / 2);
        this.cardWidth = 100 / lineCount;
        if (items.length === 1) {
            this.cardWidth = 50;
        }
        if (items.length <= maxItemsBeforeSplit) {
            result.push([...items]);
        } else {
            const firstRowCount = Math.ceil(items.length / 2); // 第一行尽量多放
            result.push(items.slice(0, firstRowCount)); // 第一行
            result.push(items.slice(firstRowCount));    // 第二行
        }

        return result;
    }
    formatPercent = (percent: number) => `${(percent*100).toFixed(0)}%`;

    getAnnualCbfTargetAndPurchase(year: string) {
        this.dealerPortalService.getAnnualCbfTargetAndPurchase({ year }).subscribe(result => {
            const { rtnCode, rtnData } = result;
            if (rtnData.length > 0) {
                rtnData.forEach((item: any) => {
                    item.icon = this.iconMap[item.productLineNameCn] || 'assets/target/box-closed.png';
                    item.progress = this.calculatePercentage(item.pendingAmountYTM, item.monthlyTarget)
                });
                this.cbfTarget = rtnData;
                this.blockData = rtnData;
            } else {
                this.cbfTarget = [];
                this.blockData = [];
            }
            this.rows = this.splitIntoRows(this.blockData);
        })
    }

    getMainContractAnnualTargetAchieve(year: string) {
        this.dealerPortalService.getMainContractAnnualTargetAchieve({ year }).subscribe(result => {
            const { rtnCode, rtnData } = result;
            const {allYear,distributedRebateAmount,usedRebateAmount, targetRebateAmount,paidRebateAmount} = rtnData;
            this.yearList = allYear;
            if (this.selectedYear === '') {
                this.selectedYear = this.yearList[0];
                localStorage.setItem("selectedYear", this.yearList[0]);
            }
            this.indicatorList[2].value =  this.multiplyFormatted(usedRebateAmount);
            this.indicatorList[1].value = paidRebateAmount;
            this.indicatorList[0].value = targetRebateAmount;
            this.latestUpdateTime = rtnData.latestUpdateTime;
            this.annualOverviews = rtnData.annualOverviews;
            this.annualResult = rtnData;
            if (this.annualOverviews.length > 0) {
                const foundItem = this.annualOverviews.find(
                    (item: any) => item.customerType === "OVERVIEW_CURRENT_YEAR_PARENT"
                );
                if (foundItem) {
                    this.annualOverview = foundItem;
                    this.pageHeaderTitle = '合并客户';
                } else {
                    this.annualOverview = this.annualOverviews[0];
                    this.pageHeaderTitle = '结算客户';
                }
            } else {
                this.annualOverview = {
                    currentTargetAchievement: 0,
                    annualPurchaseTarget: '0',
                    actualPurchaseAmount: '0',
                    quarterlyTarget: '0',
                    pendingPurchaseAmountYTM: '0',
                    quarterlyPendingPurchaseAmount: '0'
                };
                this.pageHeaderTitle = '';
            }
        })
    }

    multiplyFormatted(value: any, factor = 1.13, decimals = 2): number {
        if (value === null || value === undefined || value === '' || isNaN(value)) {
            return 0;
        }

        const result = Number(value) * factor;
        return Number(result.toFixed(decimals));
    }

    onQueryParamsChange(params: NzTableQueryParams): void {
        const { sort } = params;
        const currentSort = sort.find(item => item.value !== null);
        if (currentSort) {
            const { key, value } = currentSort;
            if (key === 'annualTarget' || key === 'purchaseAmount' || key === 'pendingAmountYTM'
                || key === 'pendingPaymentAmount' || key === 'openOrderAmount' || key === 'warehouseAmount') {
                this.cbfTarget = [...this.cbfTarget].sort((a, b) => {
                    const formattedAValue = parseFloat(String(a[key] ?? '0').replace(/,/g, ''));
                    const formattedBValue = parseFloat(String(b[key] ?? '0').replace(/,/g, ''));
                    if (formattedAValue > formattedBValue) {
                        return value === 'ascend' ? 1 : -1;
                    }
                    if (formattedAValue < formattedBValue) {
                        return value === 'ascend' ? -1 : 1;
                    }
                    return 0;
                });
            }
            if (key === 'productLineNameCn') {
                this.cbfTarget = [...this.cbfTarget].sort((a, b) => {
                    const compareResult = a[key].localeCompare(b[key], 'zh');
                    return value === 'ascend' ? compareResult : -compareResult;
                });
            }
            if (key === 'progress') {
                this.cbfTarget = [...this.cbfTarget].sort((a, b) => {
                    const formattedAValue = Number(a[key]);
                    const formattedBValue = Number(b[key]);
                    if (formattedAValue > formattedBValue) {
                        return value === 'ascend' ? 1 : -1;
                    }
                    if (formattedAValue < formattedBValue) {
                        return value === 'ascend' ? -1 : 1;
                    }
                    return 0;
                });
            }
            if (key === 'monthlyTarget') {
                this.cbfTarget = [...this.cbfTarget].sort((a, b) => {
                    const formattedAValue = a[key] === '-' ? 0 : parseFloat(a[key].replace(/,/g, ''));
                    const formattedBValue = b[key] === '-' ? 0 : parseFloat(b[key].replace(/,/g, ''));
                    if (formattedAValue > formattedBValue) {
                        return value === 'ascend' ? 1 : -1;
                    }
                    if (formattedAValue < formattedBValue) {
                        return value === 'ascend' ? -1 : 1;
                    }
                    return 0;
                });
            }
        }
    }

    calculatePercentage(strNum1: string, strNum2: string) {
        const num1 = parseFloat(strNum1.replace(/,/g, ''));
        const num2 = parseFloat(strNum2.replace(/,/g, ''));

        if (num2 === 0 || Number.isNaN(num2)) return 0; // 避免除以0

        return (((num2 - num1) / num2) * 100).toFixed(0);
    }

    roundWithCommas(value: any): string {
        if (value === '-' || value === null || value === undefined || value === '') {
            return '0';
        }
        const num = parseFloat(String(value).replace(/,/g, ''));
        if (isNaN(num)) {
            return '0';
        }
        return Math.round(num).toLocaleString();
    }
}
